import { z } from 'zod';
import { InvalidArgumentError } from '@commander-js/extra-typings';

export function validateBase(value: string) {
  const parsed = z.string().url().safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError('Value must be a valid URL');
}

const LABEL_MAX_LENGTH = 200;

export function validateLabel(value: string) {
  const parsed = z.string().max(LABEL_MAX_LENGTH).safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  throw new InvalidArgumentError(
    `Value must be up to ${LABEL_MAX_LENGTH} characters`
  );
}
